import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";

import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";
import { LayoutsModule } from "./layouts/layouts.module";
import { ExtrapagesModule } from "./extrapages/extrapages.module";

import {
  NgbAccordionModule,
  NgbNavModule,
  NgbTooltipModule,
  NgbModule,
} from "@ng-bootstrap/ng-bootstrap";

import { CarouselModule } from "ngx-owl-carousel-o";
import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { NgxEchartsModule } from "ngx-echarts";

// ✅ Interceptors reales (API Nest)
import { JwtInterceptor } from "./core/helpers/jwt.interceptor";
import { ErrorInterceptor } from "./core/helpers/error.interceptor";
import { CoreModule } from "./core/core.module";

// ❌ Fake backend (solo para modo demo)
// import { FakeBackendInterceptor } from "./core/helpers/fake-backend";

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,

    // ✅ Traducciones
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),

    // ✅ UI / Layout
    LayoutsModule,
    ExtrapagesModule,
    AppRoutingModule,
    CoreModule,

    // ✅ Plugins
    NgxEchartsModule, // más correcto que solo NgxEchartsModule
    CarouselModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
    NgbModule,
    ScrollToModule.forRoot(),
  ],
  providers: [
    // ✅ 1) JWT primero para adjuntar Authorization
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },

    // ✅ 2) Error después para capturar respuestas
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // ❌ Activar SOLO si estás sin backend real
    // { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
